import { Platform } from '../../interfaces/db';

/**
 * Configuration for integration-specific instructional videos
 *
 * To add a video for a platform:
 * 1. Get the embed URL from your video platform (Tella, Loom, YouTube, etc.)
 * 2. Add the platform to the INTEGRATION_VIDEOS object below
 * 3. The video will automatically appear in both the integration details page and support center
 */

export interface IntegrationVideo {
  title: string;
  videoUrl: string;
  description?: string;
}

export const INTEGRATION_VIDEOS: Partial<Record<Platform, IntegrationVideo>> = {
  [Platform.GOOGLE_SHEETS]: {
    title: "How to Use Trellus with Google Sheets",
    videoUrl: "https://www.tella.tv/video/parallel-dialing-in-google-sheets-ghuy/embed",
    description: "Learn how to set up and use the parallel dialer with Google Sheets"
  },
  [Platform.HUBSPOT]: {
    title: "How to Use Trellus with HubSpot",
    videoUrl: "https://www.tella.tv/video/cmbzeci0y001a0bl136nw3te8/embed",
    description: "Learn how to set up and use the parallel dialer with HubSpot"
  },
  [Platform.APOLLO]: {
    title: "How to Use Trellus with Apollo",
    videoUrl: "https://www.tella.tv/video/cm9ooyvwq00000bl6ebxa6jr0/embed",
    description: "Learn how to set up and use the parallel dialer with Apollo"
  },
  // Add more integration videos here
};

/**
 * Helper function to check if a platform has a custom video
 */
export const hasIntegrationVideo = (platform: Platform): boolean => {
  return platform in INTEGRATION_VIDEOS && !!INTEGRATION_VIDEOS[platform]?.videoUrl;
};

/**
 * Helper function to get video for a platform
 */
export const getIntegrationVideo = (platform: Platform): IntegrationVideo | null => {
  return INTEGRATION_VIDEOS[platform] || null;
};
